import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Recorder from "./recorder";
import RecordingStatus from "./recording_status";
import withStyles from "@material-ui/core/styles/withStyles";
import { getAgentRecordings, getRecordingTypes } from "../lib/RecorderService";
import * as R from "ramda";
import loading from "../lib/loading.svg";

const styles = {
  root: {
    flexGrow: 1,
    marginTop: 30
  },
  tabs: { width: "95%", lineHeight: 2, marginTop: -31 },
  tab: { fontSize: 18 }
};

const notEmpty = R.complement(R.isEmpty);

export const dropRecordingExtension = R.replace(/(\.wav|\.webm)/, "");

const pickName = R.pipe(R.pick(["group", "recording_type"]), R.values, R.join("_"))

const addCompliant = R.pipe(pickName, R.concat(R.__, "_modified"));

const getMissingRecordings = (agentRecordings, recordingTypes) =>
  R.difference(
    R.map(
      R.ifElse(
        R.prop("compliant"),
        addCompliant,
        pickName,
      ),
      recordingTypes
    ),
    R.pipe(R.values, R.flatten, R.map(dropRecordingExtension))(agentRecordings)
  );

const notNil = R.complement(R.isNil);

const formatOldRecordings = folder =>
  R.pipe(
    R.prop(folder),
    R.map(
      R.cond([
        [R.equals("inbound.wav"), R.always("inbound_generic.wav")],
        [R.equals("outbound.wav"), R.always("outbound_generic.wav")],
        [R.equals("outbound.webm"), R.always("outbound_generic.webm")],
        [R.equals("aep.wav"), R.always("medicare_aep.wav")],
        [R.equals("oep.wav"), R.always("health_oep.wav")],
        [notNil, R.identity]
      ])
    )
  );

class MainContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recordingTypes: [],
      agentRecordings: {}
    };
  }
  componentDidMount() {
    this.fetchRecordingTypes();
    this.fetchRecordings();
  }

  fetchRecordingTypes = async () => {
    try {
      const response = await getRecordingTypes();
      this.setState({ recordingTypes: response.data });
    } catch (error) {}
  };

  fetchRecordings = async () => {
    try {
      const response = await getAgentRecordings();
      this.setState({ agentRecordings: response.data });
    } catch (error) {}
  };

  renderContent = () => {
    const { classes } = this.props;
    const { agentRecordings, recordingTypes } = this.state;
    agentRecordings["in_use"] = formatOldRecordings("in_use")(agentRecordings);
    agentRecordings["under_review"] = formatOldRecordings("under_review")(agentRecordings);
    agentRecordings["missing"] = getMissingRecordings(agentRecordings, recordingTypes);
    return (
      <Tabs className={classes.tabs}>
        <TabList>
          <Tab>
            <label className={classes.tab}>Your Recordings</label>
          </Tab>
          <Tab>
            <label className={classes.tab}>New Recording</label>
          </Tab>
        </TabList>
        <TabPanel>
          <RecordingStatus agentRecordings={agentRecordings} recordingTypes={recordingTypes} />
        </TabPanel>
        <TabPanel>
          <Recorder recordingTypes={recordingTypes} fetchRecordings={this.fetchRecordings} />
        </TabPanel>
      </Tabs>
    );
  };

  allDataLoaded = () => {
    const { agentRecordings, recordingTypes } = this.state;
    return notEmpty(agentRecordings) && notEmpty(recordingTypes);
  };

  renderLoading = () => {
    return (
      <Grid
        style={{
          display: "flex",
          justifyContent: "center",
          height: "90vh",
          width: "90vw",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "white"
        }}
      >
        <img src={loading} alt="loading" />
      </Grid>
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <Grid container className={classes.root}>
        {this.allDataLoaded() ? this.renderContent() : this.renderLoading()}
      </Grid>
    );
  }
}

export default withStyles(styles)(MainContainer);
